<template>
    <div class="content pt20 scroll-warp" @scroll.passive="getScroll($event)">
        <div class="account-content bgfff">
            <matrixMenu></matrixMenu>
        </div>
        <div class="">
            <div class="por clearfix" ref="materialWarp">
                <div class="material-list" v-for="(item,index) in materialList" :key="index" ref="col" :style="item.styleText">
                    <div class="in">
                        <div class="material-btn material-btn-top clearfix">
                            <span class="time fl"><i class="icons time-icon"></i>编辑时间：{{item.pushTime}}</span>
                            <span class="caozuo fr">
                                <router-link class="icons icon-edit" :to="{path:'/onlineEdit',query:{formType:1,id:item.id}}"></router-link>
                                <a class="icons icon-del" href="javascript:void(0);" @click="delMaterial(index);"></a>
                            </span>
                        </div>
                        <div class="material-main">
                            <div class="material-theme">
                                <img :src="item.cover" width="290" height="124" />
                                <p class="ovhidden">{{item.title}}</p>
                                <router-link class="mask" target="_blank" :to="{path:'/detail',query:{formType:2,id:item.id}}">点击预览</router-link>
                            </div>
                            <div class="clearfix material-exhibit exhibit" v-for="(items,index) in item.child" :key="index">
                                <div class="fl exhibit-img">
                                    <img :src="items.cover" width="44" height="44" />
                                </div>
                                <div class="exhibit-text">
                                    <span>{{items.title}}</span>
                                </div>
                                <router-link class="mask" target="_blank" :to="{path:'/detail',query:{formType:2,id:items.id}}">点击预览</router-link>
                            </div>
                        </div>

                        <div class="material-bottom clearfix" :class="{three:$parent.vipInfo.level === 20}">
                            <span class="btn-span fl">
                                <router-link :to="{path:'/materialCenter/matrixArticle',query: {id:item.pId}}" class="icons wz-icon data-title" data-title="文章发布"></router-link>
                            </span>
                            <span class="btn-span fl">
                                <a class="icons tb-icon data-title" href="javascript:void(0);" data-title="同步到公众号后台" @click="openUser(index,1);"></a>
                            </span>
                            <span class="btn-span fl"  v-if="$parent.vipInfo.level === 20">
                                <a class="icons yq-icon data-title" href="javascript:void(0);" data-title="邀请群发" @click="openUser(index,2)"></a><i class="icons icon-lock" v-if="$parent.vipInfo.send === 0"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 邀请群发 同步到公众号后台-->
        <mediaSelect ref="invitationToGroup" @userCallback="invitationToGroup" :dataArray="mediaList" v-if="mediaList != ''"></mediaSelect>
        <!-- 是否删除提示 -->
        <Dialog ref="delNewModal" :callback="enterDelNew" type="confirm" title="提示">
            <div slot="mdBox">
                <p class="ac">是否删除该素材？</p>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import matrixMenu from './matrixMenu.vue';
import Dialog from '../../components/dialog.vue';
import mediaSelect from '../../components/mediaSelect.vue';
export default {
    components:{matrixMenu,Dialog,mediaSelect},
    data() {
        return {
            operationIndex:'',//操作的索引
            gutterWidth:'',
            finished:true,//是否允许滚动加载
            oldTop:0,
            type:1,
            pageType:'',//5是热文 3是矩整素材 2是我的收藏
            col:'5',
            page:1,
            limit:10,
            leftH:0,//瀑布流left值
            rightH:0,//瀑布流right值
            gap:20,//瀑布流间距
            waterfallW:'',
            screenWidth:'',
            materialList:[],//我的素材列表
            mediaList:[],//媒体列表
            modalType:'',//1是同步 2是邀请群发
        }
    },
    mounted() {
		let that = this;
        this.$nextTick(()=> {
            that.screenWidth = that.$refs.materialWarp.offsetWidth;
            window.addEventListener("resize",function(){
                that.screenWidth = that.$refs.materialWarp.offsetWidth;
                that.waterFall();
            });
            // that.getUesrList();
            that.getMymaterial();
        })
    },
    created() {
        this.pageType = this.$route.query.pageType;
    },
    methods: {
        // 获取收藏列表
        getMymaterial () {
            let that = this;
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('mymaterial/list',{page:that.page,pagesize:that.limit},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    let data = r.data.data
                    that.finished = true;
                    if(data.length <= 0){
                        that.$utils.alertText('没有更多数据了');
                        return;
                    }
                    for(let i of data){
                        i.styleText = '';
                    }
                    
                    if(that.page === 1){
                        that.materialList = data;
                    }else{
                        that.materialList = that.materialList.concat(data);
                    }
                    setTimeout(() => {
                        that.waterFall();
                    }, 10);
                })
            })
        },
        // 瀑布流
        waterFall(){
            let that = this;
            let materialList = that.materialList;
            let nodeList = that.$refs.col;
            // let row = 0;
            let screenWidth = that.screenWidth;
            // row = parseInt(screenWidth/330);
            let num = Math.floor(screenWidth/330);
            let minHeight = 0;
            let minHkey = 0;
            let compareArray = [];
            //遍历获取到的所有瀑布流块
            for(let i = 0;i < nodeList.length;i++){
                if(i<num){
                    //成行元素
                    compareArray[i] = nodeList[i].offsetHeight;
                    materialList[i].styleText = '';
                }else{
                    //获取成行元素中高度最低的值
                    minHeight = Math.min.apply('',compareArray);
                    //获取成行元素中高度最低元素的索引
                    minHkey = that.getMinHeightKey(compareArray,minHeight);
                    //为新增的瀑布流块设置定位
                    materialList[i].styleText = 'position:absolute;top:'+minHeight+'px;left:'+nodeList[minHkey].offsetLeft+'px';
                    // materialList[i].title = 'position:absolute;top:'+(minHeight + 20)+'px;left:'+nodeList[minHkey].offsetLeft+'px';
                    // materialList[i].position = "absolute";
                    // materialList[i].top = minHeight;
                    //设定新增加的瀑布流块的top和left
                    // materialList[i].left = nodeList[minHkey].offsetLeft;
                    //将该索引位置的高度改变为新增后的高度[原来瀑布流块的高度+新增的瀑布流块的高度]
                    compareArray[minHkey] += nodeList[i].offsetHeight;
                }
            }
            
        },
        getMinHeightKey(arr,minH){
            for(let key in arr){
                if(arr[key] == minH){
                    return key;
                }
            }
        },
        // 滚动加载
        getScroll(event) {
            // 滚动条距离底部的距离scrollBottom
            let newTop = event.target.scrollTop;
            let scrollBottom = event.target.scrollHeight - newTop - event.target.clientHeight;
            if(this.oldTop < newTop){
                if (this.finished && scrollBottom <= 0) {
                    this.page++;
                    this.finished = false;
                    this.getMymaterial();
                }
            }
            this.oldTop = newTop;
        },
        // 删除素材
        delMaterial (index) {
            let that = this;
            that.operationIndex = index;
            that.$refs.delNewModal.showMaskFun();
        },
        // 确认删除
        enterDelNew () {
            let that = this;
            let list = that.materialList;
            let pid = list[that.operationIndex].pId;
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('mymaterial/delmy', {pid:pid}, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.page = 1;
                    that.getMymaterial();
                    that.$refs.delNewModal.closeMask();
                    that.$utils.alertText('删除成功');
                })
            })
        },
        // 获取账户列表
        getUesrList () {
            
        },
        // 同步到微信
        openUser (index,type) {
            let that = this;
            let send = that.$parent.vipInfo.send;
            if(send === 0 && type === 2){//没有权限
                let html = '您没有此权限，请<span class="color-blue">联系管理员开通</span>';
                that.$parent.alertTips(html);
                return;
            }
            let url = 'member/publishlist';
            let data = {};
            if(type === 1){
                data = {
                    other:0
                }
            }
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post(url, data, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.mediaList = r.data;
                    setTimeout(() => {
                        that.$refs.invitationToGroup.synchroPublicNumber(type);
                        that.operationIndex = index;
                        that.modalType = type;
                    }, 10);
                })
            })
        },
        // 保存邀请群发
        invitationToGroup (val) {
            let that = this;
            let url = '';
            let modalType = that.modalType;
            let pid = that.materialList[that.operationIndex].pId;
            let id1 = [];//同步到微信
            let id2 = [];//邀请群发
            for(let i of val){
                let arr = [];
                let zhi = i.split('-');
                arr.push(zhi[0],zhi[1]);
                id1.push(zhi[1]);
                id2.push(arr);
            }
            let data = {};
            let tips = '';
            if(modalType === 1){//同步
                url = 'editor/sendtomywx';
                data = {
                    pid:pid,
                    id:id1
                }
                tips = '同步成功';
            }else{//邀请群发
                url = 'editor/allsend';
                data = {
                    accountid:id2,
                    pid:pid
                }
                tips = '邀请转发成功';
            }
            that.$api.post(url, data, r => {
                that.$parent.returnCode(r,function(){
                    that.$utils.alertText(tips);
                })
            })
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/materialCenter/myMaterial.vue